import {
  USA_PROVINCE_NAMES,
  USAProvinceName,
} from "@redotech/locale/provinces";
import MapIcon from "@redotech/redo-icons/map-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.state;

export const StateFilter: ArrayStringTableFilter<USAProvinceName> = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "state",
  Icon: MapIcon,
  operators: [...entry.operators],
  values: USA_PROVINCE_NAMES,
  displayName: entry.displayName,
};
